import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import SVG from 'react-inlinesvg';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import styles from './information.module.scss';

export default memo(function Information(props) {
    const [t] = useTranslation('common');

    const iconURL = props.warning ? './icons/warning.svg' : './icons/info.svg';

    return (
        <div className={styles.container}>
            <div className={styles.informationContainer}>
                <div className={styles.title}>
                    <SVG cacheGetRequests className={styles.icon} src={props.icon || iconURL} />
                    <span className={styles.title}>{props.title}</span>
                </div>
                <div className={styles.valueContainer}>
                    {props.fetching && <CircularLoader size={24} warning={props.warning} />}
                    {
                        !props.fetching &&
                        props.error &&
                        props.value &&
                        <Tooltip disableFocusListener disableTouchListener title={props.errorDescription}>
                            <div>
                                <SVG cacheGetRequests className={styles.errorIcon} src="./icons/error.svg" />
                            </div>
                        </Tooltip>
                    }
                    {
                        props.error &&
                        !props.value &&
                        !props.ip &&
                        !props.showAction &&
                        <span className={styles.noInformationAvailable}>{t('common:no_information_available')}</span>
                    }
                    {
                        props.numericValue &&
                        props.value &&
                        <CountUp className={styles.value} duration={2} end={props.value} redraw />
                    }
                    {
                        props.ip &&
                        !props.showAction &&
                        <span className={styles.ip}>{props.value}</span>
                    }
                    {
                        props.ip &&
                        props.showAction &&
                        <div className={styles.linkArea} onClick={props.onClick}>
                            <span className={styles.forwardValue}>{props.actionTitle}</span>
                        </div>
                    }
                </div>
            </div>
            {props.warning && <div className={styles.warning} />}
            {props.showError && <div className={styles.error} />}
            {props.success && <div className={styles.success} />}
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.description === nextProps.description &&
        prevProps.error === nextProps.error &&
        prevProps.errorDescription === nextProps.errorDescription &&
        prevProps.fetching === nextProps.fetching &&
        prevProps.ip === nextProps.ip &&
        prevProps.numericValue === nextProps.numericValue &&
        prevProps.goToLegacySupportSite === nextProps.goToLegacySupportSite &&
        prevProps.showAction === nextProps.showAction &&
        prevProps.success === nextProps.success &&
        prevProps.title === nextProps.title &&
        prevProps.value === nextProps.value &&
        prevProps.warning === nextProps.warning &&
        prevProps.showError === nextProps.showError &&
        prevProps.actionTitle === nextProps.actionTitle &&
        prevProps.icon === nextProps.icon
);
